<template>
  <div id="projekte">
    <!-- TITLE & BACK LINK -->
    <PageTitleDesktop class="d-none d-md-block" :title="entry.title"></PageTitleDesktop>
    <PageTitleMobile class="d-block d-md-none" :title="entry.title"></PageTitleMobile>
    <!-- CONTENT -->
    <b-container fluid>
      <b-row>
        <b-col cols="12" offset="0" md="8" offset-md="4">
          <!-- SINGLE IMAGE -->
          <img v-if="entry.projektBild != undefined && entry.projektBild.length" class="fluid space-ba-m" :src="entry.projektBild[0].url">

          <!-- LOOP FOR MATRIX INHALTE -->
          <div v-for="(item, i) in entry.projektInhalte" :key="i">

            <!-- NORMALER TEXT -->
            <div class="space-ba-m" v-if="item.__typename == 'projektInhalte_text_BlockType'">
              <h3 v-if="item.titel" class="space-ba-xs">{{item.titel}}</h3>
              <div class="type-xs a-underline" v-html="newLineText(item.text)"></div>
            </div>

            <!-- SUPERTABLE LIST -->
            <div class="space-ba-m" v-if="item.__typename == 'projektInhalte_liste_BlockType'">
              <h3 v-if="item.titel" class="space-ba-xs">{{item.titel}}</h3>
              <ul>
                <li class="type-xs a-underline" v-for="(table, j) in item.listeSuperTable" :key="j" v-html="newLineText(table.listeInhalt)"></li>
              </ul>
            </div>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PageTitleDesktop from "@/components/Shared/PageTitleDesktop";
import PageTitleMobile from "@/components/Shared/PageTitleMobile";

let axios = require("axios");

export default {
  name: "ProjektEntry",
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Basel Academy Projekte",
    // all titles will be injected into this template
    description: "Die Basel Academy ist ein wissenschaftliches Institut und Dienstleister in den Bereichen Qualitätsmessung, Versorgungsforschung und klinische Forschung.",
  }),
  data() {
    return {
      entrySlug: this.$route.params.slug,
      entry: [],
    };
  },
  components: {
    PageTitleDesktop,
    PageTitleMobile
  },
  created () {
    axios({
      url: "https://backend.basel-academy.ch/api",
      method: "POST",
      data: {
        query: `
          query {
            projekte:entries(section: "projekte", slug: "` + this.entrySlug +`", site: "${this.$i18n.locale}") {
              title
              ... on projekte_projekte_Entry {
                projektBild @transform(width: 1000, quality: 70, immediately: true, format: "jpg") {
                  url
                  title
                  width
                  height
                }
                projektInhalte {
                  ... on projektInhalte_text_BlockType {
                    __typename
                    titel
                    text
                  }
                  ... on projektInhalte_liste_BlockType {
                    __typename
                    titel
                    listeSuperTable {
                      ... on listeSuperTable_BlockType {
                        __typename
                        listeInhalt
                      }
                    }
                  }
                }
              }
            }
          }`
      }
    }).then((result) => {
      let data = result.data.data.projekte[0];
      this.entry = data;
    });
  },
  methods: {
    newLineText(el) {
      if(el){
        return el.replace(/(?:\r\n|\r|\n)/g, "<br />");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  padding-top: 2rem;
}
</style>